import React from 'react';
import classNames from 'classnames';
import { Dropdown } from 'antd';

import { Button, Menu } from '../../../../components';
import { plusIcon, Attribute } from '../rule-utils';

const BUTTON_WIDTH = '200px';
const dropDownTrigger: ('click' | 'hover')[] = ['click'];

export const getMenu = (items: Attribute[]) =>
	items.map(item =>
		item.attributes?.length
			? {
					key: item.path || item.identifier,
					label: item.title,
					title: item.title,
					children: getMenu(item.attributes),
					'data-test-id': item.identifier
			  }
			: {
					key: item.path,
					label: item.title,
					title: item.title,
					disabled: item.disabled,
					'data-test-id': item.identifier
			  }
	);

interface RuleFooterProps {
	attributes: Attribute[];
	translations: { addAttribute: string };
	addCondition(key: string): void;
	disabled?: boolean;
	isFleetRule?: boolean;
	contextSelector?: string;
}

export const RuleFooter = ({
	translations,
	contextSelector,
	attributes,
	addCondition,
	isFleetRule = false,
	disabled = false
}: RuleFooterProps) => {
	const menu = (
		<Menu
			onClick={e => addCondition(e.key as string)}
			className={classNames('attributes-menu', { [`menu-${contextSelector}`]: !!contextSelector })}
			items={getMenu(attributes)}
		/>
	);

	return (
		<div data-test-id="rule-attributes" className={isFleetRule ? 'rule-attributes' : 'rule-footer'}>
			<Dropdown
				disabled={disabled}
				overlay={menu}
				overlayStyle={{ maxWidth: BUTTON_WIDTH }}
				trigger={dropDownTrigger}
				getPopupContainer={(triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement}
			>
				<a className="dropdown-link" onClick={e => e.preventDefault()}>
					<Button
						disabled={disabled}
						type="primary"
						shape="circle"
						className="add-condition"
						icon={plusIcon}
						id={`add-attributes-to-${contextSelector}-btn`}
					/>
					{translations.addAttribute}
				</a>
			</Dropdown>
		</div>
	);
};
